module.exports = {
  "@ux/accordion": "1999.1.5",
  "@ux/alert": "1999.1.5",
  "@ux/button": "1999.1.5",
  "@ux/button-set": "1999.1.5",
  "@ux/checkbox": "1999.1.5",
  "@ux/checkbox-group": "1999.1.5",
  "@ux/code": "1999.1.5",
  "@ux/collapsible": "1999.1.5",
  "@ux/component": "1999.1.5",
  "@ux/containers": "1999.1.5",
  "@ux/criteria": "1999.1.5",
  "@ux/docs": "21.8.2",
  "@ux/dropdown": "1999.1.5",
  "@ux/fieldset": "1999.1.5",
  "@ux/form": "1999.1.5",
  "@ux/form-element": "1999.1.5",
  "@ux/form-group": "1999.1.5",
  "@ux/growl": "1999.1.5",
  "@ux/gxsys-assets": "4.0.1",
  "@ux/gxsys-page": "14.1.0",
  "@ux/icon": "1999.1.5",
  "@ux/inline-styles": "1999.1.5",
  "@ux/message-overlay": "1999.1.5",
  "@ux/modal": "1999.1.5",
  "@ux/namespace-component": "1999.0.0",
  "@ux/pagination": "1999.1.5",
  "@ux/palette-api-client": "3.1.0",
  "@ux/palettes": "1999.1.5",
  "@ux/password": "1999.1.5",
  "@ux/pivot": "1999.1.5",
  "@ux/progress-bar": "1999.1.5",
  "@ux/progress-steps": "1999.1.5",
  "@ux/quantity-selector": "1999.1.5",
  "@ux/radio": "1999.1.5",
  "@ux/radio-group": "1999.1.5",
  "@ux/react-native-device-fonts": "3.0.1",
  "@ux/remaining": "1999.1.5",
  "@ux/scss-common": "1999.1.5",
  "@ux/scss-definitions": "1999.1.5",
  "@ux/search": "1999.1.5",
  "@ux/spinner": "1999.1.5",
  "@ux/stars": "1999.1.5",
  "@ux/table": "1999.1.5",
  "@ux/tabs": "1999.1.5",
  "@ux/telephone-input": "1999.1.5",
  "@ux/toggle": "1999.1.5",
  "@ux/tooltip": "1999.1.5",
  "@ux/transition": "1999.1.5",
  "@ux/util": "1999.1.5",
  "@ux/webpack-config": "10.3.0",
  "@ux/webpack-rtl-plugin": "1999.1.5",
  "@ux/uxcore2": "1999.1.5"
};